import { onError } from '@apollo/client/link/error'
import { isArray } from '@apollo/client/utilities'
import { captureException } from '@sylveraio/react-utils/server'

export const errorLink = onError(({ graphQLErrors }) => {
  if (isArray(graphQLErrors)) {
    graphQLErrors.forEach((error) => {
      captureException(error, error?.message)
    })
  }
})
